import './style.scss';

import cn from 'classnames';
import React, { useCallback } from 'react';

import { ECexName, IDexName } from 'web3';

import { BaseSelectField } from '../base/BaseSelectField';
import { ExchangeOption } from '../ExchangeOption';

interface IExchange {
  label: string;
  exchange: IDexName | ECexName;
}

interface ISelectExchangeFieldProps {
  label?: string;
  placeholder?: string;
  items: IExchange[];
  selectedItem?: IExchange;
  onSelectItem: (v: IExchange | undefined) => void;
  disabled?: boolean;
  errorMessage?: string;
  comment?: string;
}

const SelectExchangeField: React.FC<ISelectExchangeFieldProps> = ({
  label,
  placeholder,
  items,
  selectedItem,
  onSelectItem,
  errorMessage,
  comment,
  disabled = false,
}) => {
  const renderItem = useCallback(
    ({ exchange, label }: IExchange) => {
      const isItemSelected = selectedItem && exchange === selectedItem.exchange;

      return (
        <ExchangeOption exchange={exchange} label={label} selected={Boolean(isItemSelected)} />
      );
    },
    [selectedItem],
  );

  return (
    <BaseSelectField
      className={cn('mm-select-exchange-field', { filled: !!selectedItem })}
      label={label}
      placeholder={placeholder}
      items={items}
      disabled={disabled}
      selectedItem={selectedItem}
      onSelectItem={onSelectItem}
      renderItem={renderItem}
      renderSelectedItem={renderItem}
      errorMessage={errorMessage}
      comment={comment}
    />
  );
};

export { SelectExchangeField };
